import angular from 'angular';
import { LoadParams } from '../../shared/models/loadparams.model';
import { NsjRoutingType } from '../../core/nsj-core';

type Session = {
    estabelecimento: {
        estabelecimento: string;
        codigo: string;
        nomefantasia: string;
        descricao: string;
        tipoidentificacao: number;
        raizcnpj: string;
        ordemcnpj: string;
        cpf: string;
        cidade: string;
        site: string | null;
        tipologradouro: string | null;
        logradouro: string | null;
        numero: string | null;
        complemento: string | null;
        bairro: string | null;
        cep: string | null;
        dddtel: string | null;
        telefone: string | null;
        lastupdate: string;
        tenant: number;
        empresa_guid: string;
        municipio: {
            ibge: string;
            nome: string;
            uf: string;
        };
    };
    empresa: {
        codigo: string;
        descricao: string;
        empresa: string;
        grupoempresarial: string;
        lastupdate: string;
        nomecontato: string | null;
        ordemcnpj: string;
        raizcnpj: string;
        razaosocial: string;
    };
    grupoempresarial: {
        grupoempresarial: string;
        codigo: string;
        descricao: string;
        escopoworkflowweb: number;
    };
};

export class ClientSessionService {

    static $inject = ['$rootScope', '$http', '$q', 'nsjRouting'];

    public loadParams = new LoadParams();
    public entities = {} as Session;
    private loadPromise: angular.IPromise<Session> | null = null;

    constructor(
        public $rootScope: angular.IRootScopeService,
        public $http: angular.IHttpService,
        public $q: angular.IQService,
        public nsjRouting: NsjRoutingType,
    ) {}

    load(): angular.IPromise<Session> {
        if (this.sessionCarregada()) {
            this.replaySessionLoaded();
            return this.$q.resolve(this.entities);
        }

        if (this.loadPromise) {
            return this.loadPromise;
        }

        this.loadPromise = this.$http.get<Session>(
            this.nsjRouting.generate('clientsession_session', {}, true)
        ).then(response => {
            this.entities = angular.copy(response.data);
            this.broadcastSessionLoaded(this.entities);

            return this.entities;
        }).catch(error => {
            return this.$q.reject(error);
        }).finally(() => {
            this.loadPromise = null;
        });

        return this.loadPromise;
    }

    private sessionCarregada() {
        return !!this.entities?.empresa && !!this.entities?.estabelecimento;
    }

    private replaySessionLoaded(): void {
        this.$rootScope.$evalAsync(() => {
            this.broadcastSessionLoaded(this.entities);
        });
    }

    private broadcastSessionLoaded(session: Session): void {
        this.$rootScope.$broadcast('meurh_clientsession_session_loaded_service', session);
    }
}

angular.module('main').service('ClientSession', ClientSessionService);
